var ENVIRONMENT = {
  DEVELOPMENT: "development",
  PRODUCTION: "production",
  BLUE: "blue",
  PREPROD: "preprod",
  RELEASE: "release",
  QA_BLUE: "qaBlue",
  QA: "qa",
  QA4: "qa4",
};

var envDetails = {
  getEnv,
  isEnv,
  isDevServer,
  active: ENVIRONMENT.PRODUCTION,
  activeUrl: "",
  constants: ENVIRONMENT,
  environments: {
    prod: "https://enlighten.enphaseenergy.com",
    blue: "https://enlighten-aws.enphaseenergy.com",
    preprod: "https://enlighten-preprod.enphaseenergy.com",
    release: "https://enlighten-rel.enphaseenergy.com",
    qaBlue: "https://qa2-enlighten-aws.enphaseenergy.com",
    qa: "https://qa2.enphaseenergy.com",
    qa4: "https://enlighten-qa4.enphaseenergy.com",
    notificationProd: "https://installer-settings.enphaseenergy.com",
    notificationPreProd: "https://installer-settings-preprod.enphaseenergy.com",
    notificationRelease: "https://installer-settings-rel.enphaseenergy.com",
    notificationStg: "https://installer-settings-stg.enphaseenergy.com",
    notificationDev: "https://installer-settings-dev.enphaseenergy.com",
    dev: "http://localhost:4000",
  },
};

function init() {
  setEnvironment();
  setEnvironmentURL();
}

function getApiDomain() {
  return window.build_domain_api || window.location.origin;
}

function isApiDomainSame(val) {
  return getApiDomain() === val;
}

function getEnv() {
  return window.build_environment || ENVIRONMENT.DEVELOPMENT;
}

function isEnv(val) {
  return getEnv() === val;
}

function setEnvironment() {
  envDetails.active = getEnv();
}

function setEnvironmentURL() {
  envDetails.activeUrl =
    isDevServer() && !isApiDomainSame(window.location.origin)
      ? getApiDomain()
      : window.location.origin;
}

function isDevServer() {
  return (
    isEnv(ENVIRONMENT.DEVELOPMENT) ||
    /localhost|0.0.0.0|ngrok.io/.test(window.location.origin)
  );
}

init();
module.exports = envDetails;
